module.exports = __webpack_public_path__ + "media/images/article/noimage-5e7edfbf236e8f05862b3420310e5c3e.png";